import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, CounterPill, Stack, Typography } from '@lyearn/ui';
import FilterItem from '@/components/Filter/FilterItem';
import { FilterItemTooltipProps } from '@/components/Filter/types';
import { NewFilterOption } from '@/components/FilterNew/types';

import { SelectedItemsProps } from '../types';

const SelectedItems = (props: SelectedItemsProps) => {
  const { selectedOptions, toggleOption, initialSelectedOptions, itemRenderer } = props;
  const { t } = useTranslation();

  const selectedOptionsIds = useMemo(() => {
    const initialSelectedIds = initialSelectedOptions?.map((item) => item.value);
    return selectedOptions
      .filter((item) => initialSelectedIds?.includes(item.value))
      .map((item) => item.value);
  }, [initialSelectedOptions, selectedOptions]);

  const getTooltipProps: FilterItemTooltipProps = ({ option }: { option: NewFilterOption }) => {
    return {
      title: option.label,
      variant: 'default',
      placement: 'right',
    };
  };

  return (
    <Stack direction="col">
      <Stack
        alignItems="center"
        className="mx-8 mb-2 flex h-38 items-center pe-8 ps-10"
        justifyContent="between">
        <Typography as="p" color="text-text-placeholder" variant="label-caps">
          {t('Common:Selected')}
        </Typography>
        <CounterPill label={selectedOptionsIds.length} size="small" />
      </Stack>
      <Stack className="mb-8" direction="col">
        {initialSelectedOptions.map((option, index) => {
          return (
            <Box key={`selected-${index}`} className="mx-8 h-40">
              <FilterItem
                getTooltipProps={getTooltipProps}
                isSelected={selectedOptionsIds.includes(option.value)}
                isSingleSelect={false}
                itemRenderer={itemRenderer}
                option={option}
                onClick={toggleOption}
              />
            </Box>
          );
        })}
      </Stack>
      <Typography
        as="p"
        className="mx-8 mb-2 flex h-38 items-center pe-8 ps-10"
        color="text-text-placeholder"
        variant="label-caps">
        {t('Common:All')}
      </Typography>
    </Stack>
  );
};

export default SelectedItems;
